export const handleFileDownload = async () => {
  try {
    const response = await fetch('/account_import.xlsx')
    if (!response.ok) { throw new Error('File not found!') }

    const blob = await response.blob()
    const url = window.URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.href = url
    link.download = 'account_import.xlsx'
    link.click()

    window.URL.revokeObjectURL(url)
  } catch (error) {
    alert('File not found!')
  }
}